import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import '@solana/wallet-adapter-react-ui/styles.css';

import MintInfo from '../components/MintInfo';

export default function Home() {
  return (
    <div className="h-screen w-screen flex flex-col bg-gradient-to-b from-pink-900 to-black overflow-hidden">
      <div className="hidden md:block absolute top-0 right-0 justify-between items-center py-2 px-4">
        <WalletMultiButton />
      </div>
      <div className="p-4 md:p-8 flex flex-col flex-grow items-center text-white">
        <h1 className="text-center text-4xl md:text-7xl lg:text-8xl font-bold mb-4">危ない計画竜</h1>
        <h2 className="text-center text-2xl md:text-4xl lg:text-5xl font-mono">Abunai Keikaku Dragons</h2>
        <div className="md:hidden flex flex-col flex-grow items-center justify-center">You must mint from a PC</div>
        <div className="hidden md:flex flex-col flex-grow items-center justify-center w-full">
          <MintInfo />
        </div>
        <h3 className="text-center text-sm md:text-md lg:text-lg font-mono">
          1,111 draconic reptiles terrorizing the streets of a post-apocalyptic Solana ecosystem
        </h3>
      </div>
    </div>
  );
}
